import React from "react";
import { Box, Input, Select, Option, Icon, Button } from "../elements";

export function IconField({
  classes,
  icon,
  option,
  activeOption,
  type,
  placeholder,
  passwordVisible,
  inputProps,
  error,
  ...rest
}) {
  const [visible, setVisible] = React.useState(false);

  return (
    <Box className={`mc-icon-field ${classes || "w-md h-sm white"}`} style={{ overflow: "hidden", padding: "0" }}>
      <Icon type={icon || "account_circle"} style={{ padding: "7px" }} />
      {type ? (
        <>
          <Input
            type={visible ? "text" : type || "text"}
            placeholder={type ? placeholder || "Type here..." : ""}
            inputProps={inputProps}
            error={error}
            {...rest}
          />
          {passwordVisible && (
            <Button type="button" className="material-icons" style={{ padding: "7px" }} onClick={() => setVisible(!visible)}>
              {visible ? "visibility_off" : "visibility"}
            </Button>
          )}
        </>
      ) : (
        <Select {...rest}>
          <Option>{activeOption || "Select Option"}</Option>
          {option.map((item, index) => (
            <Option key={item.id} value={item.id}>
              {item.name}
            </Option>
          ))}
        </Select>
      )}
    </Box>
  );
}
